<template>
    <b-card class="col-xs-12 col-sm-8 col-xl-4 border-0 shadow p-4">

        <h3 class="mb-5 w-100 text-center">Вход в систему</h3>

            <b-alert variant="warning" show v-if="getLoginMessage" class="mb-5">
                {{ getLoginMessage }}
            </b-alert>

            <b-form @submit.stop.prevent="onSubmit" class="d-flex flex-column align-items-center">

                <b-form-group class="w-100"
                    id="username-group"
                    label="Логин"
                    label-for="username">
                    <b-form-input
                        id="username"
                        v-model="$v.form.username.$model"
                        type="text"
                        :state="validateState('username')"
                        aria-describedby="username-live-feedback">
                    </b-form-input>
                    <b-form-invalid-feedback id="username-live-feedback">{{ validationMessageText($v.form.username) }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group class="w-100 mb-4"
                    id="password-group"
                    label="Пароль"
                    label-for="password">
                    <b-form-input
                        id="password"
                        v-model="$v.form.password.$model"
                        type="password"
                        :state="validateState('password')"
                        aria-describedby="password-live-feedback">
                    </b-form-input>

                    <b-form-invalid-feedback id="password-live-feedback">{{ validationMessageText($v.form.password) }}</b-form-invalid-feedback>
                </b-form-group>

                <div>
                    <b-button type="submit" variant="primary" :disabled="$v.$anyError">
                        <span class="mr-2">Войти</span>
                        <b-icon icon="arrow-right" />
                    </b-button>
                </div>

            </b-form>

    </b-card>
</template>

<script>

    import { validationMixin } from "vuelidate";
    import { validationMessage } from 'vuelidate-messages'
    import { required } from "vuelidate/lib/validators";
    import Constants from "../../store/auth/constants";
    import { formMessages } from "@/utils/validationMessages";
    import { mapGetters } from 'vuex';

    export default {
        name: "LoginForm",
        mixins: [validationMixin],
        data() {
            return {
                form: {
                    username: null,
                    password: null
                }
            }
        },
        computed: {
            ...mapGetters(['getLoginMessage'])
        },
        validations: {
            form: {
                username: { required },
                password: { required },
            }
        },
        methods: {
            validateState(name) {
                const { $dirty, $error } = this.$v.form[name];
                return $dirty ? !$error : null;
            },
            validationMessageText: validationMessage(formMessages, {dirty: true, first: 1}),
            onSubmit() {
                this.login();
            },
            onReset() {

            },
            login: function () {
                const vm = this;

                let next;
                if (this.$route.query) {
                    next = this.$route.query['next']
                    if (next && !next.startsWith('/')) {
                        next = '/' + next
                    }
                }
!
                vm.$store
                    .dispatch(Constants.AuthActions.AUTH_LOGIN, {'username': this.form.username, 'password': this.form.password})
                    .then((complete) => {
                        if (complete) {
                            vm.$router.push(next ? next : '/');
                        } else {
                            vm.$router.push({name: 'loginConfirmation'});
                        }
                    })
                    // .then((response) => {
                    //     if (response.data && response.data['needs_confirmation']) {
                    //          return vm.$store.dispatch(Constants.AuthActions.AUTH_AUTHENTICATE, {'userId': response.data['user_id']})
                    //     } else {
                    //         vm.$router.push('/');
                    //     }
                    // }).then(() => {
                    //     vm.$router.push({name: 'loginConfirmation'});
                    // })
                    .catch((reason) => {
                        vm.makeToast(reason.response.data['detail'], 'danger', 'Ошибка доступа');
                    })
            },
            makeToast(message, variant, title='') {
                this.$bvToast.toast(message, {title:title, autoHideDelay: 5000, variant: variant});
            }
        }
    }
</script>

<style scoped>
    input {
        border: 1px solid #ced4da;;
    }
</style>